export default () => {
  const createCurrentMarker = (point: any) => {
    return {
      ...point,
      lat: point?.value?.coordinates?.lat,
      lng: point?.value?.coordinates?.long,
      title: point?.label,
      color: "blue",
      paths: {
        lat: point?.value?.coordinates?.lat,
        lng: point?.value?.coordinates?.long,
      },
      type: "marker",
    };
  };
  const createPlaceMarker = (point: any, fitBounds = false) => {
    let location;
    point?.location?.geoJson?.features?.map((feature)=>{
      if(feature?.geometry.coordinates.length > 0){
        location = feature.geometry;
        return;
      }
    });
    return {
      ...point,
      lat: location?.coordinates?.[1],
      lng: location?.coordinates?.[0],
      title: point.beamIds?.[0] || `${point.profile.firstName}.${point.profile.lastName}`,
      color: "orange",
      paths: {
        lat: location?.coordinates?.[1],
        lng: location?.coordinates?.[0],
      },
      type: "marker",
      filter: "viewOnly",
      fitBounds,
    };
  };

  const createAssetMarker = (point: any, fitBounds = false) => {
    let obj;
    if(point?.metadata?.type === 'fixedAsset'){
      obj = point?.asset;
    }
    else if(point?.metadata?.type === 'poi'){
      obj = point?.poi;
    }
    const {location} = obj;
    return {
      ...obj,
      id: point.id,
      assetType: point?.metadata?.type,
      lat: location?.coordinates?.lat,
      lng: location?.coordinates?.long,
      title: location.attributes.title,
      color: "orange",
      paths: {
        lat: location?.coordinates?.lat,
        lng: location?.coordinates?.long,
      },
      type: "marker",
      filter: "viewOnly",
      fitBounds,
    };
  };
  return {
    createPlaceMarker,
    createCurrentMarker,
    createAssetMarker
  };
};
